import React from 'react';
import { buildKey, noop } from '@yme/common/index';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { ButtonSquare } from './ButtonSquare';
export function ButtonSquareGroup(props) {
    const { allOptions = [], possibleOptions = [], contentTag = RegularTextLevel4, defaultContentStyles, activeContentStyles, setActiveOption, selectedValue, dataTestId, isShowDisabled, } = props;
    const setIsActiveHandler = (value) => () => {
        if (setActiveOption && value) {
            setActiveOption(value);
        }
    };
    if (allOptions?.length) {
        return allOptions.map(({ value, specialValue }, index) => {
            const isSelected = value === selectedValue;
            const tagContentProps = isSelected ? activeContentStyles : defaultContentStyles;
            const isDisabled = !possibleOptions.some((i) => i === value);
            const eachKey = buildKey(value, index);
            if (isDisabled && !isShowDisabled) {
                return null;
            }
            return (React.createElement(ButtonSquare, { key: eachKey, index: index, isSelected: isSelected, value: value, isDisabled: isDisabled, setIsActive: !isSelected && !isDisabled ? setIsActiveHandler(value) : noop, tagContent: contentTag, tagContentProps: tagContentProps, specialValue: specialValue, dataTestId: dataTestId }));
        });
    }
    return null;
}
ButtonSquareGroup.displayName = 'ButtonSquareGroup_Atom';
